import useThemeStore from "./store";

export default useThemeStore;
